import { Box, Grid, Typography } from "@material-ui/core";
import JobForm from "./jobForm";
import { useParams } from "react-router-dom";

export default function JobEditPage({ disabled, ...props }) {
  let { id } = useParams();
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
        Job &gt; {id != "new" ? "Edit" : "Add"} Job
        </Typography>
      </Box>
      <Grid container xs={12}>
        <JobForm
          description="Edit Job"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
